import request from '@/router/axios'

export function getMyInfo() {
  return request({
    url: '/sys/myinfo',
    method: 'get',
  });
}
export function changePassword(password) {
  return request({
    url: '/sys/updatePwd',
    method: 'post',
    data: password
  });
}







